export const ON_PREM =
  (
    process.env.ON_PREM ||
    window.localStorage.getItem('onPremEnabled') ||
    'false'
  ).toLowerCase() === 'true';
export const ON_PREM_SENSEI_API_BASE_URL = 'https://sensei-api.density.io';
export const ON_PREM_CORE_CUCUMBER_BASE_URL =
  'https://core-cucumber.density.io';
export const ON_PREM_CORE_API_BASE_URL = 'https://api.density.io';
export const ON_PREM_ERROR_COLLECTOR_BASE_URL = 'http://localhost:5000';
